import { Directive, ElementRef, Renderer2, input, inject, effect, ChangeDetectorRef } from '@angular/core';
import CONSTANTS from '@constants';

@Directive({
  selector: '[appAvatar]',
  standalone: false
})
export class AvatarDirective {
  private elRef = inject(ElementRef);
  private renderer = inject(Renderer2);
  private cdr = inject(ChangeDetectorRef);
  readonly url = input<string>(undefined, { alias: 'appAvatar' });
  readonly appAvatarHidePlaceholder = input(false);

  constructor() {
    effect(() => {
      const imageUrl = this.url() || CONSTANTS.DEFAULT_PROFILE_PICTURE_PATH;
      this.setAvatar(imageUrl);
    });
  }

  private setAvatar(imageUrl: string) {
    if (this.appAvatarHidePlaceholder() && !this.url()) {
      this.renderer.setStyle(this.elRef.nativeElement, 'background-image', 'none');
    } else {
      this.renderer.setStyle(this.elRef.nativeElement, 'background-image', `url("${imageUrl}")`);
    }
    this.cdr.markForCheck();
  }
}
